// extracted by mini-css-extract-plugin
export default {"modal":"s_modal__Vbtf8","title":"s_title__WbJ4X","subtitle":"s_subtitle__FTkpd","description":"s_description__baOL1"};